'use strict';

function isNumeric(value) {
	return !isNaN(value - parseFloat(value));
}

module.exports = isNumeric;